<!-- ----------------------------------------------- -->
<template>
  <v-card class="com-pc-card">
    <!-- お知らせ情報一覧 -->
    <v-row
      v-if="numberInfos > 0 && firstInfo"
      align="center"
      class="card_content tm-pc-detail-info ma-0 pa-0"
    >
      <v-list
        class="tm-pc-detail-info-rw-info pa-0"
        :style="setInfoColorBySummaryCode(firstInfo.summaryCode)"
      >
        <v-list-group no-action :append-icon="numberInfos > 1 ? undefined : ''">
          <template v-slot:activator>
            <v-list-item class="pa-0">
              <v-btn
                small
                rounded
                depressed
                color="red white--text"
                v-if="numberInfos > 1"
                >{{ numberInfos }}</v-btn
              >
              <v-list-item-content class="ml-2 pa-0">
                <v-list-item-subtitle class="white--text">
                  <span class="list-rw-info-white-space">
                    <span
                      class="tm-pc-text-detail-info-icon tm-pc-detail-info-rw-span-warn"
                      >{{
                        infoConfig.infoKindCode[firstInfo.infoKindCode]
                      }}</span
                    >
                    <span
                      class="tm-pc-text-detail-info-icon tm-pc-detail-info-rw-span-warn ml-1"
                      >{{ infoConfig.summaryCode[firstInfo.summaryCode] }}</span
                    >
                    <span
                      class="ml-2 tm-pc-detail-info-text"
                      :style="setInfoTextColorBySummaryCode(firstInfo.summaryCode)"
                      >{{ getDateText(firstInfo.date) }}</span
                    >
                    <span
                      class="ml-2 tm-pc-detail-info-text"
                      :style="setInfoTextColorBySummaryCode(firstInfo.summaryCode)"
                      >{{ firstInfo.summary }}</span
                    >
                    <span>
                      <v-btn
                        class="ml-2 mb-1"
                        color="primary"
                        @click="openInfo(firstInfo.infoManageCode)"
                        max-height="24"
                      >
                        <span>{{ text.btn }}</span>
                      </v-btn>
                    </span>
                  </span>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </template>
          <div v-if="typeof listInfo !== 'undefined'">
            <v-list-item
              class="tm-pc-detail-info-rw-info"
              :style="setInfoColorBySummaryCode(info.summaryCode)"
              v-for="(info, index) in listInfo"
              :key="index"
            >
              <v-list-item-content class="pa-0">
                <v-list-item-subtitle>
                  <span class="list-rw-info-white-space">
                    <span
                      class="tm-pc-text-detail-info-icon tm-pc-detail-info-rw-span-warn"
                      >{{ infoConfig.infoKindCode[info.infoKindCode] }}</span
                    >
                    <span
                      class="tm-pc-text-detail-info-icon tm-pc-detail-info-rw-span-warn ml-1"
                      >{{ infoConfig.summaryCode[info.summaryCode] }}</span
                    >
                    <span
                      class="ml-2 tm-pc-detail-info-text"
                      :style="setInfoTextColorBySummaryCode(info.summaryCode)"
                      >{{ getDateText(info.date) }}</span
                    >
                    <span
                      class="ml-2 tm-pc-detail-info-text"
                      :style="setInfoTextColorBySummaryCode(info.summaryCode)"
                      >{{ info.summary }}</span
                    >
                    <v-btn
                      class="ml-2 mb-1"
                      color="primary"
                      @click="openInfo(info.infoManageCode)"
                      max-height="24"
                    >
                      <span>{{ text.btn }}</span>
                    </v-btn>
                  </span>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </div>
        </v-list-group>
      </v-list>
    </v-row>
  </v-card>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [PC]お知らせカード
 * TmInfo.vue
 * @author ILUKE
 */

import mixin from "./../../../lib/mixin.js";
import Util from "./../../../lib/util";

export default {
  /** タグ名 */
  name: "tm-detail-info",
  mixins: [mixin],
  data() {
    return {
      /** 文字列リソース */
      text: {
        btn: "詳細表示",
      },
    };
  },
  computed: {
    /** お知らせ設定情報 */
    infoConfig: {
      get() {
        return this.$store.state.info.informationConfig;
      },
    },
    /** お知らせ件数 */
    numberInfos: {
      get() {
        var info = this.$store.state.map.information;
        return info.length;
      },
    },
    /** お知らせ 緊急度が一番高い1件目 */
    firstInfo: {
      get() {
        var info = this.$store.state.map.tmInfo;
        return info[0];
      },
    },
    /** お知らせ一覧（1件目を除く） */
    listInfo: {
      get() {
        let infoList = Array.from(this.$store.state.map.information);
        let spliceItem = this.$store.state.map.tmInfo;
        let spliceIndex = this.getInfoItemIndex(infoList, spliceItem[0]);
        if (spliceIndex !== -1) {
          infoList.splice(spliceIndex, 1);
        }
        return infoList;
      },
    },
    appTimeRound: {
      get() {
        return this.$store.state.app.appTimeRound;
      },
    },
  },
  methods: {
    /**
     * お知らせ情報 取得
     */
    getObsInformation() {
      this.$store.dispatch("map/getObsInformation", {
        ofcCd: this.$store.state.Telemeter.selectedTmParam.ofcCd,
        itmkndCd: this.$store.state.Telemeter.selectedTmParam.itmkndCd,
        obsCd: this.$store.state.Telemeter.selectedTmParam.obsCd,
      });
    },
    /**
     * お知らせ情報  緊急度が最も高い１件目 取得
     */
    getObsInfo() {
      this.$store.dispatch("map/getObsInfo", {
        ofcCd: this.$store.state.Telemeter.selectedTmParam.ofcCd,
        itmkndCd: this.$store.state.Telemeter.selectedTmParam.itmkndCd,
        obsCd: this.$store.state.Telemeter.selectedTmParam.obsCd,
      });
    },
    /** お知らせ画面遷移 */
    openInfo(infoManageCd) {
      let routeData = this.$router.resolve({
        name: "dtlinfo",
        query: {
          infmgcd: infoManageCd,
        },
      });
      window.open(routeData.href, "_self");
    },
    /** 日時文字列変換 */
    getDateText(date) {
      return date == null ? "" : Util.formatDate24(date);
    },
    getInfoItemIndex(infoItemList, infoItem) {
      let indexList = [];
      for (var item of infoItemList) {
        indexList.push(item.infoManageCode);
      }
      let index = indexList.indexOf(infoItem.infoManageCode);
      return index;
    },
    /** summaryCodeでお知らせボタンを着色 */
    setInfoColorBySummaryCode(summaryCode) {
      if (this.infoConfig.titleSummaryCode !== undefined) {
        if (this.infoConfig.titleSummaryCode[summaryCode] !== undefined) {
          return {
            backgroundColor: this.infoConfig.titleSummaryCode[summaryCode].backGroundColor
          }
        } else {
          // 設定ファイルにないsummaryCodeの場合、その他(summaryCode=5で着色)
          const code = 5;
          return {
            backgroundColor: this.infoConfig.titleSummaryCode[code].backGroundColor
          }
        }
      } else {
        // 設定ファイルにtitleSummaryCodeが無い場合
        return {
          backgroundColor: "#ffffff"
        }
      }
    },
    /** summaryCodeでお知らせ文字を着色 */
    setInfoTextColorBySummaryCode(summaryCode) {
      if (this.infoConfig.titleSummaryCode !== undefined) {
        if (this.infoConfig.titleSummaryCode[summaryCode] !== undefined) {
          return {
            color: this.infoConfig.titleSummaryCode[summaryCode].textColor
          }
        } else {
          // 設定ファイルにないsummaryCodeの場合、その他(summaryCode=5で着色)
          const code = 5;
          return {
            color: this.infoConfig.titleSummaryCode[code].textColor
          }
        }
      } else {
        // 設定ファイルにtitleSummaryCodeが無い場合
        return {
          color: "#000000"
        }
      }
    },
  },
  watch: {
    appTimeRound() {
      this.getObsInformation();
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped></style>
